<template>
  <router-view/>
</template>
   
<style >

@import './styles/common.less'

</style>
